import React, { useState, useEffect } from 'react';
import axios from 'axios';
import { Typography } from '@mui/material';
import { GET_COMMAND_API_URL, GET_EQUIPMENT_TYPE_COMMAND_API_URL } from '../Optics/OpticApiConfig';
import CommandItem from './CommandItem';
import DescriptionEquipment from './DescriptionEquipment';

const Command = () => {
  const [equipmentList, setEquipmentList] = useState([]);
  const [typeList, setTypeList] = useState([]);
  const [commands, setCommands] = useState([]);
  const [selectedEquipment, setSelectedEquipment] = useState(null);
  const [selectedType, setSelectedType] = useState(null);
  const [error, setError] = useState(null);
  const token = localStorage.getItem('token');
  const [copiedId, setCopiedId] = useState(null); 

  const handleCopy = (id, command) => {
    const textarea = document.createElement("textarea");
    textarea.value = command;
    document.body.appendChild(textarea);
    textarea.select();
    textarea.focus(); 
    try {
      const successful = document.execCommand("copy");
      if (successful) {
        setCopiedId(id); 
        setTimeout(() => setCopiedId(null), 1000);
      } else {      
      }
    } catch (err) {     
    }
    document.body.removeChild(textarea);
  };

  const handleInputChange = (id, field, value) => {
    setCommands((prevCommands) =>
      prevCommands.map((command) =>
        command.id === id ? { ...command, [field]: value } : command
      )
    );
  };
  
  const handleApply = (id) => {
    setCommands((prevCommands) =>
      prevCommands.map((command) => {
        if (command.id !== id) return command;
  
        // Используем оригинальный шаблон команды для подстановки
        const replacements = [
          { key: "{pon}", value: command.pon },
          { key: "{port}", value: command.port },
          { key: "{comment}", value: command.comment },
          { key: "{vlanId}", value: command.vlanId },
          { key: "{macCisco}", value: command.macCisco },
          { key: "{sn}", value: command.sn },
          { key: "{mac}", value: command.mac },
          { key: "{ip}", value: command.ip },
          { key: "{ipHost}", value: command.ipHost },
          { key: "{gateway}", value: command.gateway },
        ];
  
        let updatedCommandString = command.originalCommand || command.command; 
  
        replacements.forEach(({ key, value }) => {
          if (value) {
            updatedCommandString = updatedCommandString.replace(
              new RegExp(key, "g"),
              value
            );
          }
        });
  
        return {
          ...command,
          command: updatedCommandString, 
          originalCommand: command.originalCommand || command.command, 
        };
      })
    );
  };

  useEffect(() => {
    const fetchData = async () => {
      try {
        const response = await axios.get(`${GET_EQUIPMENT_TYPE_COMMAND_API_URL}`, {
            headers: {
                Authorization: `Bearer ${token}`
            }
         });
        setEquipmentList(response.data.equipment);
        setTypeList(response.data.type);
      } catch (err) {
        setError(`Ошибка загрузки: ${err.message}`);
      }
    };
    fetchData();
  }, []);

  const handleEquipmentClick = async (equipmentId) => {
    setSelectedEquipment(equipmentId); 
    setSelectedType(null); 
    setCommands([]); 
  
    fetchCommands(equipmentId, null);
  };

  const handleTypeClick = async (typeId) => {
    setSelectedType(typeId);
    setCommands([]);
  };
  
  // Используем useEffect для вызова fetchCommands, когда изменяется selectedType
  useEffect(() => {
    if (selectedType && selectedEquipment) {
      fetchCommands(selectedEquipment, selectedType);
    }
  }, [selectedType, selectedEquipment]);


 
  const fetchCommands = async (equipmentId, typeId) => {
    if (!equipmentId || !typeId) return;
    try {
      const response = await axios.get(`${GET_COMMAND_API_URL}`, {
        params: { equipmentId, commandTypeId: typeId },
        headers: {
          Authorization: `Bearer ${token}`,
        },
      });

      // Добавляем поля pon и port в каждую команду
      const updatedCommands = response.data.map((command) => ({
        ...command,
        pon: '',
        port: '',
      }));
      setCommands(updatedCommands);
    } catch (err) {
      setError(`Ошибка загрузки команд: ${err.message}`);
    }
  };

  return (
    <div style={{ display: 'flex', height: '100vh', overflow: 'hidden' }}>
      {/* Левый блок (оборудование) */}
      <div style={{ width: '9%', backgroundColor: '#454545', padding: '1rem', overflowY: 'auto', border: '1px solid #595959' }}>
        <Typography variant="h7" style={{color:"#ffd96f"}}>Оборудование</Typography>
        <hr/>
        {equipmentList.map((item) => (
          <div
            key={item.id}
            style={{
              fontSize: '18px',
              padding: '0.5rem',
              cursor: 'pointer',
              backgroundColor: item.id === selectedEquipment ? '#000000' : 'transparent',
              borderRadius: '4px',
            }}          
          >
            <label style={{color:"#cfcfcf"}} onClick={() => handleEquipmentClick(item.id)}>{item.name}</label>
          </div>
        ))}
      </div>

       {/* Верхний блок (типы команд) */}
    <div style={{ width: '13%',  height: '95%', backgroundColor: '#595959', padding: '1rem', overflowY: 'auto', overflowX: 'auto', border: '1px solid #454545', paddingBottom: "40px" }}>
      <Typography variant="h7" style={{ color: "#ffd96f" }}>Тип</Typography>
      <hr />
      {selectedEquipment ? (
      (() => {
        const typeMapping = {
          1: [1, 3, 7, 8, 10, 11, 16, 17, 18, 33],
          2: [4, 7, 9, 11, 12, 18, 30, 34],
          3: [1, 4, 7, 9, 10, 11, 12, 13, 14, 15, 31],
          4: [1, 2, 3, 4, 5, 6, 7, 8, 19, 20, 21, 22, 23, 24, 25, 30],
          5: [1, 2, 3, 4, 5, 6, 7, 8, 21, 22, 24, 26, 27, 28],
          6: [1, 3, 4, 7, 8, 10, 12, 11, 13, 14, 18, 29, 31],
          7: [1, 7, 10, 11, 13],
          8: [18], //[1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 13, 14, 15, 16, 17, 18]
          9: [11, 12, 13, 18],
          10: [7, 9, 11, 12, 32],
          11: [2, 3, 7, 24, 28],
        };

    const filteredTypes = typeMapping[selectedEquipment] || [];

    return filteredTypes.length > 0 ? (
      typeList
        .filter((item) => filteredTypes.includes(item.id))
        .map((item) => (
          <div
            key={item.id}
            style={{
              fontSize: '16px',
              padding: '0.5rem',
              cursor: 'pointer',
              backgroundColor: item.id === selectedType ? '#000000' : 'transparent',
              borderRadius: '4px',
            }}     
          >
            <label style={{ color: "#cfcfcf" }}  onClick={() => handleTypeClick(item.id)}>{item.type}</label>
          </div>
        ))
    ) : (
      <Typography variant="body2" style={{ color: "#cfcfcf" }}>
        Выберите оборудование, соответствующее типам
      </Typography>
    );
  })()
) : null}
    </div>


      {/* Центральный блок (содержимое команд) */}
      <div style={{ flex: 3, padding: '1rem', overflowY: 'auto', paddingBottom: "50px" }}>
  {error && <Typography color="error">{error}</Typography>}
  {commands.length > 0 ? (
    <div>
      {commands.map((command) => (
        <div
          key={command.id}
          style={{
            display: 'flex',
            justifyContent: 'space-between',
            alignItems: 'center',
            padding: '10px',
            border: '1px solid #ccc',
            borderRadius: '4px',
            marginBottom: '1rem',
            background:"#272727",
            display: 'flex',
            boxShadow: "0px 0px 6px 0px #e09900",
            position: "relative", 
          }}
        >

         {/* Отображение команд */}
        <CommandItem 
          command={command} 
          copiedId={copiedId} 
          handleCopy={handleCopy} 
        />

        {/* Отображение описаний */}
        <DescriptionEquipment
          command={command}
          handleInputChange={handleInputChange}
          handleApply={handleApply}
        />  
    </div>
      ))}
    
    
    </div> 
  ) : (
    <Typography>Выберите оборудование и тип команды, чтобы отобразить данные.</Typography>
  )}
</div>
    </div>
  );
};

export default Command;